/**
 * Payment-received confirmation sound (PhonePe / UPI style ding).
 * Short cash-register blip + soft settle — used on result page and chat details.
 */
export function playPaymentSuccessSound(): void {
  try {
    const AudioCtx =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AudioCtx) return;

    const ctx = new AudioCtx();
    const now = ctx.currentTime;
    const master = ctx.createGain();
    master.gain.setValueAtTime(0.9, now);
    master.connect(ctx.destination);

    const tone = (
      freq: number,
      start: number,
      duration: number,
      peak: number,
      type: OscillatorType = 'sine'
    ) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = type;
      osc.frequency.setValueAtTime(freq, now + start);
      gain.gain.setValueAtTime(0.0001, now + start);
      gain.gain.exponentialRampToValueAtTime(peak, now + start + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + duration);
      osc.connect(gain);
      gain.connect(master);
      osc.start(now + start);
      osc.stop(now + start + duration + 0.04);
    };

    // Bright “payment received” ding (two-step confirmation)
    tone(880.0, 0.0, 0.14, 0.16, 'triangle');
    tone(1318.5, 0.08, 0.22, 0.14, 'sine');
    // Soft lower settle (cash-received body)
    tone(523.25, 0.1, 0.28, 0.06, 'triangle');
    tone(659.25, 0.18, 0.35, 0.05, 'sine');

    window.setTimeout(() => {
      void ctx.close();
    }, 700);
  } catch {
    // Ignore autoplay / AudioContext failures
  }
}
